
import { useState, useEffect } from 'react';
import { isAuthSessionValid, saveLockoutInfo, isLockoutExpired, initializeSecurePassKey } from '../utils';
import { STORAGE_KEYS } from '../types';

export const usePasswordState = () => {
  const [hasPassword, setHasPassword] = useState(false);
  const [passwordHash, setPasswordHash] = useState<string | null>(null);
  const [remainingAttempts, setRemainingAttempts] = useState(3);
  const [isLocked, setIsLocked] = useState(false);
  const [lockoutEndTime, setLockoutEndTime] = useState<Date | null>(null);

  useEffect(() => {
    // Load password state from storage
    const storedHash = localStorage.getItem(STORAGE_KEYS.PASSWORD_HASH);
    if (storedHash) {
      setPasswordHash(storedHash);
      setHasPassword(true);
      
      // Clear expired session
      if (!isAuthSessionValid()) {
        localStorage.removeItem(STORAGE_KEYS.AUTH_SESSION);
      }
    }

    // Load lockout information
    const storedLockoutInfo = localStorage.getItem(STORAGE_KEYS.LOCKOUT_INFO);
    if (storedLockoutInfo) {
      const { attempts, endTime } = JSON.parse(storedLockoutInfo);
      setRemainingAttempts(attempts);
      
      if (endTime) {
        const lockoutEnd = new Date(endTime);
        setLockoutEndTime(lockoutEnd);
        
        if (isLockoutExpired(endTime)) {
          // Reset if lockout period has expired
          setIsLocked(false);
          setRemainingAttempts(3);
          saveLockoutInfo(3, null);
        } else {
          setIsLocked(true);
        }
      }
    }

    // Initialize the secure pass key when the app loads
    initializeSecurePassKey();
  }, []);

  return {
    hasPassword,
    setHasPassword,
    passwordHash,
    setPasswordHash,
    remainingAttempts,
    setRemainingAttempts,
    isLocked,
    setIsLocked,
    lockoutEndTime,
    setLockoutEndTime,
  };
};
